import styled from 'styled-components';

export const Container = styled.div`
  display: ${({ isFlex }) => (isFlex ? 'flex' : 'block')};

  ${({ isFlex }) =>
    isFlex &&
    `
    align-items: center;
    justify-content: flex-start;

    label {
      margin: 0 4px;
    }
  `}

  label {
    order: ${({ labelPosition }) => (labelPosition === 'left' ? 0 : 2)};
  }
`;
